import { Message } from 'element-ui'

// 封装的 Message 方法
const customMessage = (options) => {
  const defaultOptions = {
    showClose: true,
    duration: 1500,
    offset: 100
  }
  const finalOptions = { ...defaultOptions, ...options }
  return Message(finalOptions)
}

// 定义 success、warning、info、error 方法
['success', 'warning', 'info', 'error'].forEach(type => {
  customMessage[type] = (message, options = {}) => {
    return customMessage({
      message,
      type,
      ...options
    })
  }
})

export default customMessage



// WEBPACK FOOTER //
// ./src/utils/message.js